import { createRouter, createWebHashHistory } from 'vue-router'
import type { RouteRecordRaw } from 'vue-router'
import type { App } from 'vue'
import { Layout } from '@/utils/routerHelper'
import { useI18n } from '@/hooks/web/useI18n'

const { t } = useI18n()

export const constantRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/',
    component: Layout,
    name: 'Root',
    meta: {
      hidden: true
    }
  },
  {
    path: '/redirect',
    component: Layout,
    name: 'Redirect',
    children: [
      {
        path: '/redirect/:path(.*)',
        name: 'Redirect1',
        component: () => import('@/views/Redirect/Redirect.vue'),
        meta: {}
      }
    ],
    meta: {
      hidden: true,
      noTagsView: true
    }
  },
  {
    path: '/login',
    component: () => import('@/views/Login/Login.vue'),
    name: 'Login',
    meta: {
      hidden: true,
      title: t('login.login'),
      noTagsView: true
    }
  },
  {
    path: '/404',
    component: () => import('@/views/Error/404.vue'),
    name: 'NoFind',
    meta: {
      hidden: true,
      title: '404',
      noTagsView: true
    }
  },
  {
    path: '/403',
    component: () => import('@/views/Error/403.vue'),
    name: 'Forbidden',
    meta: {
      hidden: true,
      title: '403',
      noTagsView: true
    }
  },
  {
    path: '/test',
    component: () => import('@/views/test/index.vue'),
    name: 'Test',
    meta: {
      hidden: true,
      title: 'test',
      noTagsView: true
    }
  }
]

export const asyncRouterMap: AppRouteRecordRaw[] = [
  {
    path: '/monitor/product',
    component: Layout,
    redirect: '/monitor/product/comprehensive',
    name: 'PerformanceMonitor',
    meta: {
      title: 'menu.performanceMonitor',
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'comprehensive',
        component: () => import('@/views/Monitor/Product/Comprehensive.vue'),
        name: 'ComprehensiveMonitor',
        meta: {
          title: 'menu.comprehensiveMonitor',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      {
        path: 'utilization',
        component: () => import('@/views/Monitor/Product/Utilization.vue'),
        name: 'UtilizationMonitor',
        meta: {
          title: 'menu.utilizationMonitor',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },       
      {
        path: 'comprehensive/compare',
        component: () => import('@/views/Monitor/Product/ComprehensiveCompare.vue'),
        name: 'ComprehensiveCompare',
        meta: {
          title: 'menu.performanceCompare',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },                  
      {
        path: 'performance/rank',
        component: () => import('@/views/Monitor/Product/PerformanceRank.vue'),
        name: 'PerformanceRank',
        meta: {
          title: 'menu.performanceRank',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      // {
      //   path: 'fault/statistics',
      //   component: () => import('@/views/Monitor/Product/FaultStatistics.vue'),
      //   name: 'FaultStatistics',
      //   meta: {
      //     title: 'menu.faultStatistics',
      //     noCache: true,
      //     affix: true,
      //     hideBreadcrumb:false
      //   }
      // }            
    ]    
  },
  {
    path: '/monitor/device',
    component: Layout,
    redirect: '/monitor/device/production',
    name: 'DevicePmsMonitor',
    meta: {
      title: 'menu.machinePerformance', //'menu.performanceDetail'
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children: [
      {
        path: 'production',
        component: () => import('@/views/Monitor/Device/Production.vue'),
        name: 'ProductionMonitor',
        meta: {
          title: 'menu.productionMonitor',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },      
      {
        path: 'performance',
        component: () => import('@/views/Monitor/Device/PerformanceDetail.vue'),
        name: 'DevicePmsDetail',
        meta: {
          title: 'menu.machineDetail',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      // {
      //   path: 'compare',
      //   component: () => import('@/views/Monitor/Device/PerformanceCompare.vue'),
      //   name: 'DevicePmsCompare',
      //   meta: {
      //     title: 'menu.machineCompare',
      //     noCache: true,
      //     affix: true,
      //     hideBreadcrumb:false
      //   }
      // }      
    ]    
  },
  {
    path: '/performance/analysis',
    component: Layout,
    redirect: '/performance/analysis/utilization',
    name: 'PerformanceAnalysis',
    meta: {
      title: 'menu.performanceAnalysis',
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children:[
      {
        path: 'utilization',
        component: () => import('@/views/Analysis/Utilization.vue'),
        name: 'UtilizationAnalysis',
        meta: {
          title: 'menu.utilizationAnalysis',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      }, 
      {
        path: 'trend',
        component: () => import('@/views/Analysis/Trend.vue'),
        name: 'trendAnalysis',
        meta: {
          title: 'menu.trendAnalysis',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      {
        path: 'fault',
        component: () => import('@/views/Analysis/FaultAnalysis.vue'),
        name: 'FaultAnalysis',
        meta: {
          title: 'menu.faultAnalysis',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      {
        path: 'loss',
        component: () => import('@/views/Analysis/LossAnalysis.vue'),
        name: 'LossAnalysis',
        meta: {
          title: 'menu.lossAnalysis',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      {
        path: 'status',
        component: () => import('@/views/Analysis/Status.vue'),
        name: 'StatusAnalysis',
        meta: {
          title: 'menu.statusAnalysis',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      {
        path: 'report',
        component: () => import('@/views/Analysis/Report.vue'),
        name: 'AvailabilityReport',
        meta: {
          title: 'menu.availabilityReport',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      }             
    ]
  },
  {
    path: '/setting',
    component: Layout,
    redirect: '/setting/basic',
    name: 'Setting',
    meta: {
      title: 'menu.setting',
      icon: 'bx:bxs-component',
      alwaysShow: true
    },
    children:[
      {
        path: 'basic',
        component: () => import('@/views/Settings/Basic.vue'),
        name: 'BasicSetting',
        meta: {
          title: 'menu.basicSetting',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },           
      {
        path: 'kpi/setting',
        component: () => import('@/views/Settings/Kpi/setting.vue'),
        name: 'KPISetting',
        meta: {
          title: 'menu.ruleSetting',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },
      {
        path: 'kpi',
        component: () => import('@/views/Settings/Kpi/index.vue'),
        name: 'KPI',
        meta: {
          title: 'menu.ruleIndicators',
          noCache: true,
          affix: true,
          hideBreadcrumb:false
        }
      },       
      {
        path: 'device',
        component: () => import('@/views/Settings/DeviceInfo.vue'),
        name: 'DeviceInfoSetting',
        meta: {
          title: 'menu.setMachineInfo',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },       
      {
        path: 'precautions',
        component: () => import('@/views/Settings/Precautions.vue'),
        name: 'Precautions',
        meta: {
          title: 'menu.precautions',
          noCache: true,
          affix: true,
          hideBreadcrumb:true
        }
      },       
    ]
  },
  // {
  //   path: '/indicator',
  //   component: Layout,
  //   redirect: '/indicator/lib',
  //   name: 'Indicator',
  //   meta: {
  //     title: '指标管理',
  //     icon: 'bx:bxs-component',
  //     alwaysShow: true
  //   },
  //   children:[
  //     {
  //       path: 'lib',
  //       component: () => import('@/views/Indicator/Lib.vue'),
  //       name: 'IndicatorLib',
  //       meta: {
  //         title: '指标库',
  //         noCache: true,
  //         affix: true,
  //         hideBreadcrumb:false
  //       }
  //     },           
  //     {
  //       path: 'custom',
  //       component: () => import('@/views/Indicator/Custom.vue'),
  //       name: 'IndicatorCustom',
  //       meta: {
  //         title: '自选指标',
  //         noCache: true,
  //         affix: true,
  //         hideBreadcrumb:false
  //       }
  //     }      
  //   ]
  // }  
]

const router = createRouter({
  history: createWebHashHistory(),
  strict: true,
  routes: constantRouterMap as RouteRecordRaw[],
  scrollBehavior: () => ({ left: 0, top: 0 })
})

export const resetRouter = (): void => {
  const resetWhiteNameList = ['Redirect', 'Login', 'NoFind', 'Root']
  router.getRoutes().forEach((route) => {
    const { name } = route
    if (name && !resetWhiteNameList.includes(name as string)) {
      router.hasRoute(name) && router.removeRoute(name)
    }
  })
}

export const setupRouter = (app: App<Element>) => {
  app.use(router)
}

export default router
